export class ClinicResourceModel {
    resource_code: string
    resource_name: string

    constructor(
        resource_code: string,
        resource_name: string
    ) {
        this.resource_code = resource_code
        this.resource_name = resource_name
    }
}